/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { documentsList } from "../../funcs/documentsList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListDocumentsRequest$inboundSchema,
};

export const tool$documentsList: ToolDefinition<typeof args> = {
  name: "documents-list",
  description: `List documents within an index

Retrieve a list of all documents.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await documentsList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
